import { Box, CircularProgress, Paper, Typography } from "@mui/material";
import { PageHeader } from "@components/ui_v2";

/**
 * Pantalla de marcador de posición para `PreparandoContratos` en productos sin pantalla dedicada todavía.
 */
export const PreparandoContratosPendiente = () => (
  <Box>
    <PageHeader
      eyebrow="Formalización · Generación de contratos"
      title="Estamos preparando tus contratos"
      subtitle="Generamos los documentos contractuales con los datos validados de tu expediente. Te notificaremos cuando estén listos."
    />

    <Paper
      variant="lendia_paper"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        gap: 1.5,
        py: 8,
        px: 4,
      }}
    >
      <Box
        sx={{
          width: 72,
          height: 72,
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: "primary.base",
        }}
      >
        <CircularProgress size={36} thickness={4} />
      </Box>

      <Typography variant="h6" fontWeight={700}>
        Procesando…
      </Typography>
    </Paper>
  </Box>
);
